import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { CaseStudyCard as CaseStudyCardType } from '@/types/pages';
import { imageUrlBuilder } from '@/utils/helpers';

const CaseStudyCard: React.FC<CaseStudyCardType> = ({ slug, client, title, cardImage, industries }) => {
  const imgSrc = cardImage?.image?.asset
    ? imageUrlBuilder.image(cardImage.image.asset).width(600).auto('format').quality(80).url()
    : null;

  // Cards surface only the industry taxonomy, not every combined value.
  const industryLine = (industries ?? []).map((t) => t.title).join(' / ');

  return (
    <Link href={`/case-studies/${slug}`} className="group block">
      <div className="relative mb-3 w-full overflow-hidden rounded-md bg-a-off-white" style={{ paddingTop: '56.25%' }}>
        {imgSrc ? (
          <Image
            src={imgSrc}
            alt={cardImage?.alt || title}
            fill
            sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
            className="object-cover transition-transform duration-300 group-hover:scale-105"
          />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-sm text-a-text-muted">{client}</span>
          </div>
        )}
      </div>
      {client && <p className="mb-1 text-xs font-semibold uppercase tracking-widest text-a-text-secondary">{client}</p>}
      <h3 className="mb-3 mt-0 text-lg font-bold leading-snug text-a-navy transition-colors group-hover:text-a-orange">
        {title}
      </h3>
      {industryLine && <p className="mt-0 text-xs text-a-text-secondary">{industryLine}</p>}
    </Link>
  );
};

export default CaseStudyCard;
